import { LocationList } from './lookup.interface';
import { ProvinceList } from './location-provincelist';
import { StateList } from './location-statelist';

export const CountryList: LocationList = {
  AF: { displayName: 'Afghanistan', code: 'AF' },
  AX: { displayName: 'Åland Islands', code: 'AX' },
  AL: { displayName: 'Albania', code: 'AL' },
  DZ: { displayName: 'Algeria', code: 'DZ' },
  AS: { displayName: 'American Samoa', code: 'AS' },
  AD: { displayName: 'Andorra', code: 'AD' },
  AO: { displayName: 'Angola', code: 'AO' },
  AI: { displayName: 'Anguilla', code: 'AI' },
  AQ: { displayName: 'Antarctica', code: 'AQ' },
  AG: { displayName: 'Antigua and Barbuda', code: 'AG' },
  AR: { displayName: 'Argentina', code: 'AR' },
  AM: { displayName: 'Armenia', code: 'AM' },
  AW: { displayName: 'Aruba', code: 'AW' },
  AU: { displayName: 'Australia', code: 'AU' },
  AT: { displayName: 'Austria', code: 'AT' },
  AZ: { displayName: 'Azerbaijan', code: 'AZ' },
  BS: { displayName: 'Bahamas', code: 'BS' },
  BH: { displayName: 'Bahrain', code: 'BH' },
  BD: { displayName: 'Bangladesh', code: 'BD' },
  BB: { displayName: 'Barbados', code: 'BB' },
  BY: { displayName: 'Belarus', code: 'BY' },
  BE: { displayName: 'Belgium', code: 'BE' },
  BZ: { displayName: 'Belize', code: 'BZ' },
  BJ: { displayName: 'Benin', code: 'BJ' },
  BM: { displayName: 'Bermuda', code: 'BM' },
  BT: { displayName: 'Bhutan', code: 'BT' },
  BO: { displayName: 'Bolivia, Plurinational State of', code: 'BO' },
  BQ: { displayName: 'Bonaire, Sint Eustatius and Saba', code: 'BQ' },
  BA: { displayName: 'Bosnia and Herzegovina', code: 'BA' },
  BW: { displayName: 'Botswana', code: 'BW' },
  BV: { displayName: 'Bouvet Island', code: 'BV' },
  BR: { displayName: 'Brazil', code: 'BR' },
  IO: { displayName: 'British Indian Ocean Territory', code: 'IO' },
  BN: { displayName: 'Brunei Darussalam', code: 'BN' },
  BG: { displayName: 'Bulgaria', code: 'BG' },
  BF: { displayName: 'Burkina Faso', code: 'BF' },
  BI: { displayName: 'Burundi', code: 'BI' },
  CV: { displayName: 'Cabo Verde', code: 'CV' },
  KH: { displayName: 'Cambodia', code: 'KH' },
  CM: { displayName: 'Cameroon', code: 'CM' },
  CA: { key: 'Canada', displayName: 'Canada', code: 'CA', default: true, subLocation: ProvinceList, isCanada: true },
  KY: { displayName: 'Cayman Islands', code: 'KY' },
  CF: { displayName: 'Central African Republic', code: 'CF' },
  TD: { displayName: 'Chad', code: 'TD' },
  CL: { displayName: 'Chile', code: 'CL' },
  CN: { displayName: 'China', code: 'CN' },
  CX: { displayName: 'Christmas Island', code: 'CX' },
  CC: { displayName: 'Cocos (Keeling) Islands', code: 'CC' },
  CO: { displayName: 'Colombia', code: 'CO' },
  KM: { displayName: 'Comoros', code: 'KM' },
  CG: { displayName: 'Congo', code: 'CG' },
  CD: { displayName: 'Congo, Democratic Republic of the', code: 'CD' },
  CK: { displayName: 'Cook Islands', code: 'CK' },
  CR: { displayName: 'Costa Rica', code: 'CR' },
  CI: { displayName: "Côte d'Ivoire", code: 'CI' },
  HR: { displayName: 'Croatia', code: 'HR' },
  CU: { displayName: 'Cuba', code: 'CU' },
  CW: { displayName: 'Curaçao', code: 'CW' },
  CY: { displayName: 'Cyprus', code: 'CY' },
  CZ: { displayName: 'Czechia', code: 'CZ' },
  DK: { displayName: 'Denmark', code: 'DK' },
  DJ: { displayName: 'Djibouti', code: 'DJ' },
  DM: { displayName: 'Dominica', code: 'DM' },
  DO: { displayName: 'Dominican Republic', code: 'DO' },
  EC: { displayName: 'Ecuador', code: 'EC' },
  EG: { displayName: 'Egypt', code: 'EG' },
  SV: { displayName: 'El Salvador', code: 'SV' },
  GQ: { displayName: 'Equatorial Guinea', code: 'GQ' },
  ER: { displayName: 'Eritrea', code: 'ER' },
  EE: { displayName: 'Estonia', code: 'EE' },
  SZ: { displayName: 'Eswatini', code: 'SZ' },
  ET: { displayName: 'Ethiopia', code: 'ET' },
  FK: { displayName: 'Falkland Islands (Malvinas)', code: 'FK' },
  FO: { displayName: 'Faroe Islands', code: 'FO' },
  FJ: { displayName: 'Fiji', code: 'FJ' },
  FI: { displayName: 'Finland', code: 'FI' },
  FR: { displayName: 'France', code: 'FR' },
  GF: { displayName: 'French Guiana', code: 'GF' },
  PF: { displayName: 'French Polynesia', code: 'PF' },
  TF: { displayName: 'French Southern Territories', code: 'TF' },
  GA: { displayName: 'Gabon', code: 'GA' },
  GM: { displayName: 'Gambia', code: 'GM' },
  GE: { displayName: 'Georgia', code: 'GE' },
  DE: { displayName: 'Germany', code: 'DE' },
  GH: { displayName: 'Ghana', code: 'GH' },
  GI: { displayName: 'Gibraltar', code: 'GI' },
  GR: { displayName: 'Greece', code: 'GR' },
  GL: { displayName: 'Greenland', code: 'GL' },
  GD: { displayName: 'Grenada', code: 'GD' },
  GP: { displayName: 'Guadeloupe', code: 'GP' },
  GU: { displayName: 'Guam', code: 'GU' },
  GT: { displayName: 'Guatemala', code: 'GT' },
  GG: { displayName: 'Guernsey', code: 'GG' },
  GN: { displayName: 'Guinea', code: 'GN' },
  GW: { displayName: 'Guinea-Bissau', code: 'GW' },
  GY: { displayName: 'Guyana', code: 'GY' },
  HT: { displayName: 'Haiti', code: 'HT' },
  HM: { displayName: 'Heard Island and McDonald Islands', code: 'HM' },
  VA: { displayName: 'Holy See', code: 'VA' },
  HN: { displayName: 'Honduras', code: 'HN' },
  HK: { displayName: 'Hong Kong', code: 'HK' },
  HU: { displayName: 'Hungary', code: 'HU' },
  IS: { displayName: 'Iceland', code: 'IS' },
  IN: { displayName: 'India', code: 'IN' },
  ID: { displayName: 'Indonesia', code: 'ID' },
  IR: { displayName: 'Iran, Islamic Republic of', code: 'IR' },
  IQ: { displayName: 'Iraq', code: 'IQ' },
  IE: { displayName: 'Ireland', code: 'IE' },
  IM: { displayName: 'Isle of Man', code: 'IM' },
  IL: { displayName: 'Israel', code: 'IL' },
  IT: { displayName: 'Italy', code: 'IT' },
  JM: { displayName: 'Jamaica', code: 'JM' },
  JP: { displayName: 'Japan', code: 'JP' },
  JE: { displayName: 'Jersey', code: 'JE' },
  JO: { displayName: 'Jordan', code: 'JO' },
  KZ: { displayName: 'Kazakhstan', code: 'KZ' },
  KE: { displayName: 'Kenya', code: 'KE' },
  KI: { displayName: 'Kiribati', code: 'KI' },
  KP: { displayName: "Korea, Democratic People's Republic of", code: 'KP' },
  KR: { displayName: 'Korea, Republic of', code: 'KR' },
  KW: { displayName: 'Kuwait', code: 'KW' },
  KG: { displayName: 'Kyrgyzstan', code: 'KG' },
  LA: { displayName: "Lao People's Democratic Republic", code: 'LA' },
  LV: { displayName: 'Latvia', code: 'LV' },
  LB: { displayName: 'Lebanon', code: 'LB' },
  LS: { displayName: 'Lesotho', code: 'LS' },
  LR: { displayName: 'Liberia', code: 'LR' },
  LY: { displayName: 'Libya', code: 'LY' },
  LI: { displayName: 'Liechtenstein', code: 'LI' },
  LT: { displayName: 'Lithuania', code: 'LT' },
  LU: { displayName: 'Luxembourg', code: 'LU' },
  MO: { displayName: 'Macao', code: 'MO' },
  MG: { displayName: 'Madagascar', code: 'MG' },
  MW: { displayName: 'Malawi', code: 'MW' },
  MY: { displayName: 'Malaysia', code: 'MY' },
  MV: { displayName: 'Maldives', code: 'MV' },
  ML: { displayName: 'Mali', code: 'ML' },
  MT: { displayName: 'Malta', code: 'MT' },
  MH: { displayName: 'Marshall Islands', code: 'MH' },
  MQ: { displayName: 'Martinique', code: 'MQ' },
  MR: { displayName: 'Mauritania', code: 'MR' },
  MU: { displayName: 'Mauritius', code: 'MU' },
  YT: { displayName: 'Mayotte', code: 'YT' },
  MX: { displayName: 'Mexico', code: 'MX' },
  FM: { displayName: 'Micronesia, Federated States of', code: 'FM' },
  MD: { displayName: 'Moldova, Republic of', code: 'MD' },
  MC: { displayName: 'Monaco', code: 'MC' },
  MN: { displayName: 'Mongolia', code: 'MN' },
  ME: { displayName: 'Montenegro', code: 'ME' },
  MS: { displayName: 'Montserrat', code: 'MS' },
  MA: { displayName: 'Morocco', code: 'MA' },
  MZ: { displayName: 'Mozambique', code: 'MZ' },
  MM: { displayName: 'Myanmar', code: 'MM' },
  NA: { displayName: 'Namibia', code: 'NA' },
  NR: { displayName: 'Nauru', code: 'NR' },
  NP: { displayName: 'Nepal', code: 'NP' },
  NL: { displayName: 'Netherlands, Kingdom of the', code: 'NL' },
  NC: { displayName: 'New Caledonia', code: 'NC' },
  NZ: { displayName: 'New Zealand', code: 'NZ' },
  NI: { displayName: 'Nicaragua', code: 'NI' },
  NE: { displayName: 'Niger', code: 'NE' },
  NG: { displayName: 'Nigeria', code: 'NG' },
  NU: { displayName: 'Niue', code: 'NU' },
  NF: { displayName: 'Norfolk Island', code: 'NF' },
  MK: { displayName: 'North Macedonia', code: 'MK' },
  MP: { displayName: 'Northern Mariana Islands', code: 'MP' },
  NO: { displayName: 'Norway', code: 'NO' },
  OM: { displayName: 'Oman', code: 'OM' },
  PK: { displayName: 'Pakistan', code: 'PK' },
  PW: { displayName: 'Palau', code: 'PW' },
  PS: { displayName: 'Palestine, State of', code: 'PS' },
  PA: { displayName: 'Panama', code: 'PA' },
  PG: { displayName: 'Papua New Guinea', code: 'PG' },
  PY: { displayName: 'Paraguay', code: 'PY' },
  PE: { displayName: 'Peru', code: 'PE' },
  PH: { displayName: 'Philippines', code: 'PH' },
  PN: { displayName: 'Pitcairn', code: 'PN' },
  PL: { displayName: 'Poland', code: 'PL' },
  PT: { displayName: 'Portugal', code: 'PT' },
  PR: { displayName: 'Puerto Rico', code: 'PR' },
  QA: { displayName: 'Qatar', code: 'QA' },
  RE: { displayName: 'Réunion', code: 'RE' },
  RO: { displayName: 'Romania', code: 'RO' },
  RU: { displayName: 'Russian Federation', code: 'RU' },
  RW: { displayName: 'Rwanda', code: 'RW' },
  BL: { displayName: 'Saint Barthélemy', code: 'BL' },
  SH: { displayName: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH' },
  KN: { displayName: 'Saint Kitts and Nevis', code: 'KN' },
  LC: { displayName: 'Saint Lucia', code: 'LC' },
  MF: { displayName: 'Saint Martin (French part)', code: 'MF' },
  PM: { displayName: 'Saint Pierre and Miquelon', code: 'PM' },
  VC: { displayName: 'Saint Vincent and the Grenadines', code: 'VC' },
  WS: { displayName: 'Samoa', code: 'WS' },
  SM: { displayName: 'San Marino', code: 'SM' },
  ST: { displayName: 'Sao Tome and Principe', code: 'ST' },
  SA: { displayName: 'Saudi Arabia', code: 'SA' },
  SN: { displayName: 'Senegal', code: 'SN' },
  RS: { displayName: 'Serbia', code: 'RS' },
  SC: { displayName: 'Seychelles', code: 'SC' },
  SL: { displayName: 'Sierra Leone', code: 'SL' },
  SG: { displayName: 'Singapore', code: 'SG' },
  SX: { displayName: 'Sint Maarten (Dutch part)', code: 'SX' },
  SK: { displayName: 'Slovakia', code: 'SK' },
  SI: { displayName: 'Slovenia', code: 'SI' },
  SB: { displayName: 'Solomon Islands', code: 'SB' },
  SO: { displayName: 'Somalia', code: 'SO' },
  ZA: { displayName: 'South Africa', code: 'ZA' },
  GS: { displayName: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  SS: { displayName: 'South Sudan', code: 'SS' },
  ES: { displayName: 'Spain', code: 'ES' },
  LK: { displayName: 'Sri Lanka', code: 'LK' },
  SD: { displayName: 'Sudan', code: 'SD' },
  SR: { displayName: 'Suriname', code: 'SR' },
  SJ: { displayName: 'Svalbard and Jan Mayen', code: 'SJ' },
  SE: { displayName: 'Sweden', code: 'SE' },
  CH: { displayName: 'Switzerland', code: 'CH' },
  SY: { displayName: 'Syrian Arab Republic', code: 'SY' },
  TW: { displayName: 'Taiwan', code: 'TW' },
  TJ: { displayName: 'Tajikistan', code: 'TJ' },
  TZ: { displayName: 'Tanzania, United Republic of', code: 'TZ' },
  TH: { displayName: 'Thailand', code: 'TH' },
  TL: { displayName: 'Timor-Leste', code: 'TL' },
  TG: { displayName: 'Togo', code: 'TG' },
  TK: { displayName: 'Tokelau', code: 'TK' },
  TO: { displayName: 'Tonga', code: 'TO' },
  TT: { displayName: 'Trinidad and Tobago', code: 'TT' },
  TN: { displayName: 'Tunisia', code: 'TN' },
  TR: { displayName: 'Türkiye', code: 'TR' },
  TM: { displayName: 'Turkmenistan', code: 'TM' },
  TC: { displayName: 'Turks and Caicos Islands', code: 'TC' },
  TV: { displayName: 'Tuvalu', code: 'TV' },
  UG: { displayName: 'Uganda', code: 'UG' },
  UA: { displayName: 'Ukraine', code: 'UA' },
  AE: { displayName: 'United Arab Emirates', code: 'AE' },
  GB: { displayName: 'United Kingdom of Great Britain and Northern Ireland', code: 'GB' },
  UM: { displayName: 'United States Minor Outlying Islands', code: 'UM' },
  US: { key: 'UnitedStates', displayName: 'United States of America', code: 'US', subLocation: StateList },
  UY: { displayName: 'Uruguay', code: 'UY' },
  UZ: { displayName: 'Uzbekistan', code: 'UZ' },
  VU: { displayName: 'Vanuatu', code: 'VU' },
  VE: { displayName: 'Venezuela, Bolivarian Republic of', code: 'VE' },
  VN: { displayName: 'Viet Nam', code: 'VN' },
  VG: { displayName: 'Virgin Islands (British)', code: 'VG' },
  VI: { displayName: 'Virgin Islands (U.S.)', code: 'VI' },
  WF: { displayName: 'Wallis and Futuna', code: 'WF' },
  EH: { displayName: 'Western Sahara', code: 'EH' },
  YE: { displayName: 'Yemen', code: 'YE' },
  ZM: { displayName: 'Zambia', code: 'ZM' },
  ZW: { displayName: 'Zimbabwe', code: 'ZW' },
};

export const CountryListWithUnknown: LocationList = {
  Unknown: { code: 'UNKNOWN', displayName: 'Unknown' },
  ...CountryList,
};
export function DefaultCountry() {
  const filterCountry = Object.keys(CountryList).filter((i) => CountryList[i].default);
  const defaultCountry = filterCountry[0];
  return defaultCountry;
}
